import authApi from '../../repos/auth'

const state = {
    hasFetchedUser: false,
    authenticatedUser: null,
    authRedirect: ''
};

const getters = {
    isLoggedIn(state) {
        return !!state.authenticatedUser;
    }
};

const actions = {
    getMe(context) {
        if (context.state.hasFetchedUser) {
            return Promise.resolve();
        }

        return authApi.getMe()
            .then(user => {
                context.commit('userFetchSuccess', user)
            })
            .catch(() => {
                context.commit('userFetchSuccess', null)
            })
        ;
    },
    login(context, credentials) {
        return authApi.login(credentials)
            .then(user => {
                context.commit('loginSuccess', user);
            })
        ;
    },
    logout(context) {
        return authApi.logout()
            .then(() => {
                context.commit('logoutSuccess');
            })
            .catch(() => {
                context.commit('logoutSuccess');
            })
        ;
    }
};

const mutations = {
    setAuthRedirect(state, uri) {
        state.authRedirect = uri;
    },
    userFetchSuccess(state, user) {
        state.hasFetchedUser = true;
        state.authenticatedUser = user;
    },
    loginSuccess(state, user) {
        state.authenticatedUser = user;
        state.hasFetchedUser = true;
    },
    logoutSuccess(state) {
        state.authenticatedUser = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
